import React from 'react';

import SystemUsersFilters from './filters/SystemUsersFilters';
import UserTable from './table/UserTable';

function SystemUsers() {
  return (
    <>
      <SystemUsersFilters />

      <UserTable />
    </>
  );
}

export default SystemUsers;
